import type { LeadScoringResponse } from "@io-spoke/contracts/leadScoring";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@components/ui/card";

export function LeadNextActions({ result }: { result: LeadScoringResponse }) {
  return (
    <Card className="border-border/70">
      <CardHeader>
        <CardTitle className="text-base">Recommended next actions</CardTitle>
        <CardDescription>
          Prioritized suggestions based on the strongest buyer-fit signals.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ol className="space-y-2">
          {result.nextActions.map((action) => (
            <li
              key={action.key}
              className="rounded-lg border border-border/60 bg-background/60 p-3"
            >
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="text-sm font-medium">{action.label}</div>
                <div className="text-xs text-muted-foreground">
                  Priority {action.priority}
                </div>
              </div>
              {action.description ? (
                <p className="mt-1 text-xs text-muted-foreground">{action.description}</p>
              ) : null}
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
}

